module.exports = __webpack_public_path__ + "img/icon-edit-normal.ea8d8513.svg";